import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import type React from "react";
import Text from "@commons/Typography/Text";

type Option = { value: string | number; label: string };

type MultiSelectInputProps = {
  label?: string;
  options: Option[];
  value: Array<string | number>;
  onChange: (value: Array<string | number>) => void;
};

function MultiSelectInput({
  label,
  options,
  value,
  onChange,
}: MultiSelectInputProps) {
  const handleChange =
    (optionValue: string | number) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.checked) {
        const new_values = [...value, optionValue];
        onChange(new_values);
      } else {
        const new_values = value.filter((v) => v !== optionValue);
        onChange(new_values);
      }
    };

  return (
    <FormControl component="fieldset" className="w-full">
      {label && (
        <div className="mb-2">
          <Text>{label}</Text>
        </div>
      )}
      <div className="flex gap-x-2 flex-wrap">
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={
              <Checkbox
                checked={value.includes(option.value)}
                onChange={handleChange(option.value)}
                data-testid={`checkbox-${option.value}`}
                icon={
                  <span className="block w-6 h-6 border-2 border-primary rounded-md bg-white shadow-md" />
                }
                checkedIcon={
                  <span className="relative w-6 h-6 border-2 border-primary rounded-md bg-primary flex items-center justify-center shadow-md">
                    <svg
                      className="w-4 h-4"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 10 18 4 12" />
                    </svg>
                  </span>
                }
              />
            }
            label={<Text size="sm">{option.label}</Text>}
          />
        ))}
      </div>
    </FormControl>
  );
}

export default MultiSelectInput;
